module.exports = __webpack_public_path__ + "static/media/calender.f0adfe47.svg";